import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';

import Agent from '../api/Agent';
import { handleError } from './user';
import mixpanelConstants from '../constants/mixpanel';

const INITIAL_STATE = {
	isSubmitting: false,
	npsScore: null,
	question: null,
	showErrorMessage: null,
	showNpsForm: null,
	showSuccessMessage: null,
	userFeedback: null
};

export const resetSubmit = createAction('RESET_NPS_SUBMIT');
export const setNPSScore = createAction('SET_NPS_SCORE');
export const setUserFeedback = createAction('SET_USER_FEEDBACK');
export const setShowNpsForm = createAction('SET_SHOW_NPS_FORM');
export const setShowSuccessMessage = createAction('SET_SHOW_SUCCESS_MSG');
export const setShowErrorMessage = createAction('SET_SHOW_ERROR_MSG');
export const setIsSubmittingNPS = createAction('SET_IS_SUBMITTING_NPS');
export const setNPSQuestion = createAction('SET_NPS_QUESTION');

const reducer = handleActions(
	{
		RESET_NPS_SUBMIT: () => ({ ...INITIAL_STATE }),
		SET_IS_SUBMITTING_NPS: (state, action) => ({ ...state, isSubmitting: action.payload }),
		SET_NPS_QUESTION: (state, action) => ({ ...state, question: action.payload }),
		SET_NPS_SCORE: (state, action) => ({ ...state, npsScore: action.payload }),
		SET_SHOW_ERROR_MSG: (state, action) => ({ ...state, showErrorMessage: action.payload }),
		SET_SHOW_NPS_FORM: (state, action) => ({ ...state, showNpsForm: action.payload }),
		SET_SHOW_SUCCESS_MSG: (state, action) => ({ ...state, showSuccessMessage: action.payload }),
		SET_USER_FEEDBACK: (state, action) => ({ ...state, userNPS: action.payload })
	},
	INITIAL_STATE
);

export const getNPSQuestion = () => (dispatch) => {
	return Agent.getNPSQuestion().then((response) => {
		if (response.ok) {
			dispatch(setNPSQuestion(response.data));
			const isQuestionAvailable = response.data && !!response.data.question;
			const npsQuestion = isQuestionAvailable && response.data;

			if (isQuestionAvailable) {
				dispatch(setShowNpsForm(true));
				mixpanel.track(mixpanelConstants.VIEW_NPS_SURVEY, { ...npsQuestion });
			}
		} else {
			dispatch(handleError(response));
		}
	});
};

export const submitNPS = (npsDetails) => (dispatch, getState) => {
	const npsData = {
		feedback: npsDetails.feedback,
		nps_id: npsDetails.npsId,
		point: npsDetails.score
	};

	dispatch(setIsSubmittingNPS(true));

	return Agent.submitNPS(npsData).then((response) => {
		dispatch(setIsSubmittingNPS(false));
		if (response.ok) {
			mixpanel.track(mixpanelConstants.SUBMIT_NPS_SURVEY, { ...npsData, ...getState().nps.question });
			dispatch(setShowNpsForm(null));
			dispatch(setShowSuccessMessage(true));
			dispatch(setNPSScore(npsData.point));
		} else {
			dispatch(setShowNpsForm(null));
			dispatch(setShowErrorMessage(true));
		}
	});
};

export default reducer;
